import {GameFont} from '../../GameFont'
import {UIGameBaseAchievementView} from './UIGameBaseAchievementView'
import {UIGameManager} from '../UIGameManager'
import {InGameAchievement} from './UIGameAchievementController'
import {PlayerColor} from '@colonist/game-states'

export class UIGameStolenAchievementView extends UIGameBaseAchievementView {
    constructor(options: InGameAchievement, uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, avatarSize: number) {
        super(options, uiGameManager, x, y, w, h, avatarSize)
        this.titleSection.createTitle()
        this.titleSection.createAchievementScore()
        this.titleSection.createAchievementIcon()
        if(this.achievementOptions.achievementOwnerPrevious == PlayerColor.None) return

        const previousOwnerAvatar = this.descriptionSection.createAvatar(this.margin, this.achievementOptions.achievementOwnerPrevious)

        const arrowIcon = this.descriptionSection.createGreenArrowIcon(previousOwnerAvatar)

        const previousOwnerName = this.descriptionSection.createPlayerName(arrowIcon.x, previousOwnerAvatar, GameFont.Size.Normal, this.achievementOptions.achievementOwnerPrevious)
        this.descriptionSection.centralizePlayerAvatarAndName(previousOwnerAvatar, previousOwnerName, this.descriptionSection.x, arrowIcon.x)
        this.descriptionSection.createVPChangeView(previousOwnerName, false)

        const currentOwnerContainerX = arrowIcon.x + arrowIcon.width
        const currentOwnerAvatarX = currentOwnerContainerX + this.margin
        const currentOwnerAvatar = this.descriptionSection.createAvatar(currentOwnerAvatarX, this.achievementOptions.achievementOwnerNew)
        const currentOwnerName = this.descriptionSection.createPlayerName(this.descriptionSection.width, currentOwnerAvatar, GameFont.Size.Normal, this.achievementOptions.achievementOwnerNew)
        this.descriptionSection.centralizePlayerAvatarAndName(currentOwnerAvatar, currentOwnerName, currentOwnerContainerX, this.descriptionSection.width)
        this.descriptionSection.createVPChangeView(currentOwnerName, true)

        this.drawBackground()
    }
}
